import { PolicyValidator, Policy, checkLicense, checkScope } from '../policy.interface';

export const scopes = {
    VIEW_ALL_ORDERS: 'metrica_stamp:VIEW_ALL_ORDERS',
    VERIFY_PAYMENT: 'metrica_stamp:VERIFY_PAYMENT',
    ASSIGN_VENDOR: 'metrica_stamp:ASSIGN_VENDOR',
    VERIFY_DRAFT: 'metrica_stamp:VERIFY_DRAFT',
    VERIFY_STAMP: 'metrica_stamp:VERIFY_STAMP',
    MANAGE_ARTICLE_TYPES: 'metrica_stamp:MANAGE_ARTICLE_TYPES',
};

const appPolicy = {
    validate: (policy: Policy) => {
        return checkLicense(policy, 'metrica_stamp');
    },
    ...Object.fromEntries(
        Object.entries(scopes).map(([key, value]) => [
            `can${key.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join('')}`,
            (policy: Policy) => checkScope(policy, value)
        ])
    )
} as any; 

export default appPolicy;
